import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

/**
 *  „FRISSÍTÉS FOLYAMATBAN" — a sima felhasználó várakozó oldala.
 *
 *  Nem hibaüzenet: a rendszer nem romlott el, csak épp frissül. Ezért megmondjuk,
 *  mi történik, és hogy nem kell semmit tenni — az oldal magától visszaenged.
 *  Enélkül a felhasználó frissítgetné a böngészőt, vagy azt hinné, elromlott valami.
 */
@Component({
  selector: 'app-frissites-folyamatban',
  templateUrl: './frissites-folyamatban.component.html',
  styleUrls: ['./frissites-folyamatban.component.scss'],
})
export class FrissitesFolyamatbanComponent implements OnInit, OnDestroy {
  uzenet = 'A rendszer frissítése folyamatban van.';
  lepes: string | null = null;
  eltelt = 0;
  private idozito: any = null;
  private ora: any = null;

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit() {
    this.kerdez();
    // Három másodperc: elég gyakori ahhoz, hogy azonnal visszaengedjen, és elég ritka
    // ahhoz, hogy az épp újrainduló kiszolgálót ne terhelje feleslegesen.
    this.idozito = setInterval(() => this.kerdez(), 3000);
    this.ora = setInterval(() => { this.eltelt += 1; }, 1000);
  }

  ngOnDestroy() {
    if (this.idozito) clearInterval(this.idozito);
    if (this.ora) clearInterval(this.ora);
  }

  get elteltSzoveg(): string {
    const p = Math.floor(this.eltelt / 60);
    const m = this.eltelt % 60;
    return p ? `${p} perc ${m} másodperce` : `${m} másodperce`;
  }

  private async kerdez() {
    try {
      const r: any = await firstValueFrom(this.http.get('/api/frissites/publikus'));
      if (r?.karbantartas) {
        this.uzenet = r.uzenet || this.uzenet;
        this.lepes = r.lepes || null;
        return;
      }
      this.vissza();
    } catch (e) {
      /*  A kiszolgáló épp újraindul: a hiba itt VÁRHATÓ, nem baj. Nem írunk ki
       *  hibaüzenetet, csak várunk tovább – különben pont a normális működés
       *  látszana meghibásodásnak. */
    }
  }

  private vissza() {
    let cel = '/';
    try { cel = sessionStorage.getItem('karbantartas-vissza') || '/'; } catch (e) { /* ignore */ }
    try { sessionStorage.removeItem('karbantartas-vissza'); } catch (e) { /* ignore */ }
    if (cel.startsWith('/frissites-folyamatban')) cel = '/';
    /*  Teljes újratöltés, nem csak útvonalváltás: frissítés után a böngészőben lévő
     *  felület RÉGI verzió. Ha csak navigálnánk, a régi kód beszélne az új
     *  kiszolgálóval – pont az a fajta néma eltérés, amit el akarunk kerülni. */
    window.location.replace(cel);
  }
}
